module.exports = __webpack_public_path__ + "img/sales-management-icon.2ea02f1b.svg";